'use strict';

var appDom = require('../../app-dom');
var lazyImage = require('lazy-image-3.0.0');
var lazyImageInstance;
var prevIndex = 0;

function scrollItemIntoContainer(container, item) {
    const containerRect = container.getBoundingClientRect();
    const itemRect = item.getBoundingClientRect();
    const itemTopInContent = (itemRect.top - containerRect.top) + container.scrollTop;
    const itemBottomInContent = itemTopInContent + itemRect.height;
  
    // let top;
    // if (align === "top") {
    //     top = itemTopInContent;
    // } else if (align === "bottom") {
    //     top = itemBottomInContent - container.clientHeight;
    // } else if (align === "center") {
    //     top = itemTopInContent - (container.clientHeight / 2) + (itemRect.height / 2);
    // }

    let top = itemTopInContent - (container.clientHeight / 2) + (itemRect.height / 2);
  
    const maxTop = container.scrollHeight - container.clientHeight;
    top = Math.max(0, Math.min(top, maxTop));
  
    container.scrollTo({ top, behavior: "smooth" });
}

function handleArrowClickEventListener(accordionEl) {

    const prevBtn = accordionEl.querySelector(".arrows .prev");
    const nextBtn = accordionEl.querySelector(".arrows .next");
  
    const images = accordionEl.querySelectorAll(".images-accordion-image");
    const titles = accordionEl.querySelectorAll(".images-accordion-title");
    const scrollContainer = accordionEl.querySelector(".images-accordion-title-scroll");
  
    if (!prevBtn || !nextBtn) return;
  
    function setActive(index) {
        images.forEach(img => img.classList.remove("active"));
        titles.forEach(title => title.classList.remove("active"));
    
        const newImage = accordionEl.querySelector(
            `.images-accordion-image[data-item-index="${index}"]`
        );
        const newTitle = accordionEl.querySelector(
            `.images-accordion-title[data-item-index="${index}"]`
        );

        scrollItemIntoContainer(scrollContainer, newTitle);
    
        if (newImage) newImage.classList.add("active");
        if (newTitle) newTitle.classList.add("active");
        refreshLazyLoad();
    }
  
    function getCurrentIndex() {
        const activeImage = accordionEl.querySelector(".images-accordion-image.active");
        return activeImage
            ? parseInt(activeImage.dataset.itemIndex, 10)
            : 1;
    }
  
    const totalItems = images.length;
  
    prevBtn.addEventListener("click", () => {
        let index = getCurrentIndex() - 1;
        if (index < 1) index = totalItems;
        setActive(index);
    });
  
    nextBtn.addEventListener("click", () => {
        let index = getCurrentIndex() + 1;
        if (index > totalItems) index = 1;
        setActive(index);
    });
}

function handleTitleClickEventListener(accordionEl) {
    const titles = accordionEl.querySelectorAll(".images-accordion-title");
    const images = accordionEl.querySelectorAll(".images-accordion-image");
    const scrollContainer = accordionEl.querySelector(".images-accordion-title-scroll");

    titles.forEach(title => {
        title.addEventListener("click", () => {
            const itemIndex = title.dataset.itemIndex;
            if (!itemIndex) return;

            titles.forEach(x => x.classList.remove("active"));
            title.classList.add("active");
            images.forEach(img => img.classList.toggle("active", img.dataset.itemIndex === itemIndex));

            scrollItemIntoContainer(scrollContainer, title);

            refreshLazyLoad();

            prevIndex = itemIndex;
        });
    });
}

function refreshLazyLoad() {
    if (appDom.app.find('[data-lazy-image]').length) {
        lazyImageInstance.refresh();
    }
}

function handleAutoplay(accordionEl) {

    var autoplay = accordionEl.dataset.autoplay === "1";
    var speed = parseInt(accordionEl.dataset.speed, 10) || 5;

    if (!autoplay) return;

    var images = accordionEl.querySelectorAll(".images-accordion-image");
    var totalItems = images.length;

    var interval = null;

    function getCurrentIndex() {
        var activeImage = accordionEl.querySelector(".images-accordion-image.active");
        return activeImage
            ? parseInt(activeImage.dataset.itemIndex, 10)
            : 1;
    }

    function setActive(index) {
        var titles = accordionEl.querySelectorAll(".images-accordion-title");
        var scrollContainer = accordionEl.querySelector(".images-accordion-title-scroll");

        images.forEach(img => img.classList.remove("active"));
        titles.forEach(title => title.classList.remove("active"));

        var newImage = accordionEl.querySelector(
            `.images-accordion-image[data-item-index="${index}"]`
        );
        var newTitle = accordionEl.querySelector(
            `.images-accordion-title[data-item-index="${index}"]`
        );

        if (newImage) newImage.classList.add("active");
        if (newTitle) newTitle.classList.add("active");

        scrollItemIntoContainer(scrollContainer, newTitle);
        refreshLazyLoad();
    }

    function next() {
        var index = getCurrentIndex() + 1;
        if (index > totalItems) index = 1;
        setActive(index);
    }

    function start() {
        stop();
        interval = setInterval(next, speed * 1000);
    }

    function stop() {
        if (interval) clearInterval(interval);
    }

    accordionEl.addEventListener("click", stop);

    start();
}

var init = function() {

    var accordionLayouts = document.querySelectorAll('.images-accordion');

    if (appDom.app.find('[data-lazy-image]').length) {

        lazyImageInstance = lazyImage({
            watchOffsetYTop: 500,
            watchOffsetYBottom: 500
        });

    }

    accordionLayouts.forEach(function(accordionEl) {
        handleTitleClickEventListener(accordionEl);
        handleArrowClickEventListener(accordionEl);
        handleAutoplay(accordionEl);
    });
    
};

module.exports = {
    init: init
};